import React from 'react';
import { IconProps } from './types';

const WarningIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} width="72" height="72" fill="none" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M36 2.25C31.5679 2.25 27.1792 3.12297 23.0844 4.81907C18.9897 6.51516 15.2691 9.00117 12.1351 12.1351C9.00117 15.2691 6.51516 18.9897 4.81907 23.0844C3.12297 27.1792 2.25 31.5679 2.25 36C2.25 40.4321 3.12297 44.8208 4.81907 48.9156C6.51516 53.0103 9.00117 56.7309 12.1351 59.8649C15.2691 62.9988 18.9897 65.4848 23.0844 67.1809C27.1792 68.877 31.5679 69.75 36 69.75C40.4321 69.75 44.8208 68.877 48.9156 67.1809C53.0103 65.4848 56.7309 62.9988 59.8649 59.8649C62.9988 56.7309 65.4848 53.0103 67.1809 48.9156C68.877 44.8208 69.75 40.4321 69.75 36C69.75 31.5679 68.877 27.1792 67.1809 23.0844C65.4848 18.9897 62.9988 15.2691 59.8649 12.1351C56.7309 9.00117 53.0103 6.51516 48.9156 4.81907C44.8208 3.12297 40.4321 2.25 36 2.25Z"
      stroke="#404040"
      stroke-width="2.25"
      stroke-linecap="round"
    />
    <path
      d="M36 13.5V40.5M36 50.625C35.1049 50.625 34.2464 50.9806 33.6135 51.6135C32.9806 52.2465 32.625 53.1049 32.625 54C32.625 54.8951 32.9806 55.7535 33.6135 56.3865C34.2464 57.0194 35.1049 57.375 36 57.375C36.8951 57.375 37.7535 57.0194 38.3865 56.3865C39.0194 55.7535 39.375 54.8951 39.375 54C39.375 53.1049 39.0194 52.2465 38.3865 51.6135C37.7535 50.9806 36.8951 50.625 36 50.625Z"
      stroke="#FF6400"
      stroke-width="2.25"
      stroke-linecap="round"
    />
  </svg>
);

export default WarningIcon;
